import getDomainPathFromPathReduxUtil from '../get-domain-path-from-path'

export default function getByProfileIdDomainListPathReduxUtil (domainListPath, profileId) {
  if (!profileId) {
    return domainListPath
  }
  const domainListPathArr = domainListPath.split('.')
  // e.g. workouts.byProfileId.33624.planned.data
  return `${getDomainPathFromPathReduxUtil(domainListPath)}.byProfileId.${profileId}.${domainListPathArr[domainListPathArr.length -
  1]}`
}
